
import { Vue, Component } from 'vue-property-decorator'
import * as tool from '@/utils/tool'
import { TeaConfig } from '@/const/dashboard'

@Component({
  name: 'Pixel',
})
export default class Pixel extends Vue {
  TeaConfig = TeaConfig;

  mounted() {
    this.$trackEvent('adp_waplite_impression', {
      'dashboard_campaign': 'dash_mobiletopc_bestpractice_pixelpage',
    })
  }

  data() {
    return {
      quoteBgs: [
        require('@/assets/images/promotional/pixel/bg_quote_bg1.svg'),
        require('@/assets/images/promotional/pixel/bg_quote_bg2.svg'),
        require('@/assets/images/promotional/pixel/bg_quote_bg3.svg'),
        require('@/assets/images/promotional/pixel/bg_quote_bg4.svg'),
        require('@/assets/images/promotional/pixel/bg_quote_bg5.svg'),
        require('@/assets/images/promotional/pixel/bg_quote_bg6.svg'),
      ],
      bannerLowerList: [
        {
          icon: require('@/assets/images/promotional/pixel/icon_setting_config.svg'),
          text: 'Optimize ad delivery',
        },
        {
          icon: require('@/assets/images/promotional/pixel/icon_user_positioning.svg'),
          text: 'Create custom audiences',
        },
        {
          icon: require('@/assets/images/promotional/pixel/icon_list_view.svg'),
          text: 'Measure the results',
        },
      ]
    }
  }

  copyURL() {
    tool.accessPC()
  }
}

